import { Component, Input, OnInit, Output, EventEmitter, Host, Optional } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { ToastrService } from 'ngx-toastr';

import { UserPostsDataService } from '../../../services/posts.service';
import { ScoreService } from '../../../services/scores.service';
//import { PostMedia } from '../../interfaces/post-media.interface'; // Adjust the path as needed

import { GifModalComponent } from '../../../modals/gif-modal/gif-modal.component';
import { PostSubmitModalComponent } from '../../../modals/post-submit-modal/post-submit-modal.component';


import *  as Classes from '../../../classes/models.classes'

@Component({
    selector: 'app-post-footer',
    templateUrl: './post-footer.component.html',
    styleUrls: ['./post-footer.component.css']
})
export class PostFooterComponent implements OnInit {

    @Input() Username: string;
    @Input() UserID: number;
    //@Input() postData: Classes.ShortsPostSave;
    @Input() hasPostText: boolean = false; // Receives true/false from parent
    @Input() pageType!: string; 
    //@Input() modalInstance?: PostSubmitModalComponent;  // Receive modal instance

    //@Output() postEditedOrDeleted = new EventEmitter<void>();
    //@Output() postContent = new EventEmitter<string>(); 
    @Output() mediaUrlsChange = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() onSave = new EventEmitter<void>();   

    UserPostsData: Array<Classes.ShortsPosts>;
    UserPostsDataContent: Classes.ShortsPostSave;

    currentPage = 1;
    pageSize = 10;
    isLoading = false;
    allPostsLoaded = false; // Flag to check if all posts are loaded

    selectedScoreTypeID: number | null = null;
    //selectedScoreTypeId: number | null = null;
    selectedScoreTypeIDs: { [key: number]: number } = {};
    showDetails: { [key: number]: boolean } = {};
    selectedScoreDetails: { [key: number]: Classes.ScoreDetails[] } = {};

    reactions: any = {};

    selectedFile: File | null = null;
    selectedFileUrl: string;

    selectedGifPreviewUrl: string;
    selectedGifAnimatedUrl: string;

    hasImageContent: boolean = false; // Tracks whether there is image content to enable post button
    isMediaProcessed: boolean = false;

    public replyType: number = 1; // Default to 'Everyone'
    replyColor = '#0d6efd'; // Default light blue
    textColor = '#000'; // Default black text

    replyTypes = [
        {
            id: 1,
            text: 'Everyone',
            icon: this.sanitizer.bypassSecurityTrustHtml(`
            <svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20" fill="currentColor" style="color: ${this.replyColor};">
                <g><path
                    d="M12 1.75C6.34 1.75 1.75 6.34 1.75 12S6.34 22.25 12 22.25 22.25 17.66 22.25 12 17.66 1.75 12 1.75zm-.25 10.48L10.5 17.5l-2-1.5v-3.5L7.5 9 5.03 7.59c1.42-2.24 3.89-3.75 6.72-3.84L11 6l-2 .5L8.5 9l5 1.5-1.75 1.73zM17 14v-3l-1.5-3 2.88-1.23c1.17 1.42 1.87 3.24 1.87 5.23 0 1.3-.3 2.52-.83 3.61L17 14z">
                </path></g>
            </svg>`)
        },
        {
            id: 2,
            text: 'Accounts You Follow',
            icon: this.sanitizer.bypassSecurityTrustHtml(`
            <svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20" fill="currentColor" style="color: ${this.replyColor};">
                <g><path
                    d="M10 4c-1.105 0-2 .9-2 2s.895 2 2 2 2-.9 2-2-.895-2-2-2zM6 6c0-2.21 1.791-4 4-4s4 1.79 4 4-1.791 4-4 4-4-1.79-4-4zM3.651 19h12.698c-.337-1.8-1.023-3.21-1.945-4.19C13.318 13.65 11.838 13 10 13s-3.317.65-4.404 1.81c-.922.98-1.608 2.39-1.945 4.19zm.486-5.56C5.627 11.85 7.648 11 10 11s4.373.85 5.863 2.44c1.477 1.58 2.366 3.8 2.632 6.46l.11 1.1H1.395l.11-1.1c.266-2.66 1.155-4.88 2.632-6.46z">
                </path></g>
            </svg>`)
        },
        {
            id: 3,
            text: 'Verified Accounts',
            icon: this.sanitizer.bypassSecurityTrustHtml(`
            <svg viewBox = "0 0 22 22" aria-hidden="true" width="20" height="20" fill="currentColor" style="color: ${this.replyColor};">
                <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z" fill = "#1d9bf0" > 
                </path>
            </svg>`)
        },
        {
            id: 4,
            text: 'Only Accounts You Mention',
            icon: this.sanitizer.bypassSecurityTrustHtml(`
            <svg viewBox = "0 0 22 22" aria-hidden="true" width="20" height="20" fill="currentColor" style="color: ${this.replyColor};">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.75464 12C4.75464 7.99594 8.00057 4.75 12.0046 4.75C16.0087 4.75 19.2546 7.99594 19.2546 12C19.2546 12.0337 19.2569 12.0668 19.2612 12.0993C19.2579 12.1307 19.2567 12.1626 19.2574 12.1949C19.2636 12.4495 19.231 12.8444 19.1474 13.2219C19.0563 13.6331 18.9376 13.8694 18.8682 13.9423C18.5663 14.2591 18.1509 14.4429 17.7135 14.4535C17.276 14.464 16.8522 14.3003 16.5354 13.9984C16.3283 13.801 16.2689 13.5113 16.2527 12.8381L16.1372 8.04002C16.1273 7.62592 15.7835 7.29831 15.3694 7.30828C14.9553 7.31825 14.6277 7.66201 14.6377 8.07611L14.6543 8.76875C13.9332 8.17672 13.0104 7.82135 12.0046 7.82135C9.69686 7.82135 7.82605 9.69216 7.82605 11.9999C7.82605 14.3077 9.69686 16.1785 12.0046 16.1785C13.279 16.1785 14.4202 15.608 15.1866 14.7084C15.2726 14.8392 15.376 14.9655 15.5006 15.0843C16.1054 15.6606 16.9144 15.9731 17.7495 15.953C18.5847 15.9329 19.3777 15.5819 19.9541 14.9771C20.3238 14.5892 20.5109 14.0022 20.6119 13.5463C20.7203 13.0566 20.7662 12.5406 20.757 12.1588C20.7563 12.1313 20.7542 12.1042 20.7507 12.0775C20.7533 12.052 20.7546 12.0262 20.7546 12C20.7546 7.16751 16.8371 3.25 12.0046 3.25C7.17215 3.25 3.25464 7.16751 3.25464 12C3.25464 16.8325 7.17215 20.75 12.0046 20.75C14.0477 20.75 15.929 20.0489 17.4183 18.8747C17.7435 18.6182 17.7993 18.1466 17.5428 17.8213C17.2864 17.4961 16.8148 17.4403 16.4895 17.6968C15.2554 18.6698 13.6988 19.25 12.0046 19.25C8.00057 19.25 4.75464 16.0041 4.75464 12ZM12.0046 9.32135C10.5253 9.32135 9.32605 10.5206 9.32605 11.9999C9.32605 13.4793 10.5253 14.6785 12.0046 14.6785C13.484 14.6785 14.6832 13.4793 14.6832 11.9999C14.6832 10.5206 13.484 9.32135 12.0046 9.32135Z" />
            </svg>`)
        }
    ];

    selectedReplyType = this.replyTypes[0];  // default to Everyone


    mediaUrls: any[] = [];  // This will include URLs, indexing, and any relevant flags

    activeIndex: number = 0;

    responsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    constructor(
        private userPostsDataService: UserPostsDataService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private modalService: NgbModal
        //@Host() @Optional()
        //private modalComponent?: PostSubmitModalComponent


    ) {}

    ngOnInit(): void {
        this.UserPostsData = new Array<Classes.ShortsPosts>();
        this.UserPostsDataContent = new Classes.ShortsPostSave();
    }

    get uniqueFileInputId(): string {
        return `videoUpload_${this.pageType}`;
    }

    openGifModal(): void {
        if (this.mediaUrls.length >= 4) return;
        const modalRef = this.modalService.open(GifModalComponent, { size: 'lg' });
        modalRef.componentInstance.gifSelected.subscribe((gifData: { previewUrl: string; animatedUrl: string }) => {
            // Set the URLs from the received object
            this.selectedGifPreviewUrl = gifData.previewUrl;
            this.selectedGifAnimatedUrl = gifData.animatedUrl;

            this.handleGifSelected(gifData);
        });
    }

    handleGifSelected(gifData: { previewUrl: string; animatedUrl: string }): void {
        const index = this.mediaUrls.length;
        const newItem = {
            url: gifData.previewUrl,
            isTenor: true,
            isPlaying: false,
            animatedUrl: gifData.animatedUrl,
            previewUrl: gifData.previewUrl,
            index: index  // Keeping track of item's index
        };
        this.mediaUrls.push(newItem);
        this.mediaUrlsChange.emit(this.mediaUrls);
        this.hasImageContent = true;
        console.log("Footer GIFs this.mediaUrls: ", this.mediaUrls);  // Log the entire event to see what properties are available
    }

    setReplyType(replyType: any) {
        this.selectedReplyType = replyType;
        this.replyTypeChange.emit(this.selectedReplyType);
    }

    triggerFileUpload(): void {
        this.isMediaProcessed = false;

        //document.getElementById('videoUpload')!.click();

        document.getElementById(this.uniqueFileInputId)?.click();


        //    this.mediaUrlsChange.emit([...this.mediaUrls]); 
        //setTimeout(() => {
        //    console.log("Retrying Emit for Modal from triggerFileUpload:", this.mediaUrls);
        //    this.mediaUrlsChange.emit(this.mediaUrls);
        //}, 8000);

        //setTimeout(() => {
        //    if (this.isMediaProcessed) {  // Only emit if `checkVideo()` has run
        //        console.log("Retrying Emit for Modal from triggerFileUpload:", this.mediaUrls);
        //        this.mediaUrlsChange.emit(this.mediaUrls);
        //    } else {
        //        console.warn("checkVideo() did not complete before timeout. Retrying...");
        //        setTimeout(() => {
        //            console.log("FINAL Emit for Modal after Retry:", this.mediaUrls);
        //            this.mediaUrlsChange.emit(this.mediaUrls);
        //        }, 8000);  // Give it more time if needed
        //    }
        //}, 8000);

    }

    checkVideo(event: any): void {
        this.selectedFile = event.target.files[0];

        if (!this.selectedFile) {
            return;
        }
        const mimeType = this.selectedFile.type; // Extract the MIME type

        // Clear the file input to allow re-upload of the same file if necessary
        event.target.value = '';

        // Handle video files separately
        if (this.selectedFile.type.startsWith('video/')) {
            // Check the file type
            if (this.selectedFile.type !== 'video/mp4' && this.selectedFile.type !== 'video/quicktime') {
                alert('Unsupported video format. Please upload a MP4 or MOV file.');
                return;
            }

            // Load the file into a video element to check duration
            const video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;

                if (duration > 120) { // Check if video is longer than 2 minutes
                    alert('Video is too long. Maximum allowed duration is 2 minutes.');
                } else {
                    //alert('Video is valid. Duration: ' + duration + ' seconds.');

                    const index = this.mediaUrls.length; // Get the next index
                    const mediaItem = {
                        //url: URL.createObjectURL(this.selectedFile),
                        url: URL.createObjectURL(this.selectedFile),
                        file: this.selectedFile,
                        isVideo: true,
                        isTenor: false,  // Assuming you're handling only local files here
                        isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                        animatedUrl: null, // Not applicable for local files
                        previewUrl: null,   // For local files, the preview and actual URLs are the same
                        mimeType: mimeType, // Store the extracted MIME type
                        index: index       // Tracking the index of the new item
                    };

                    this.mediaUrls.push(mediaItem);
                    console.log("Footer is emitting Videos/Images: ", [...this.mediaUrls]);  // Log emitted data'
                    this.mediaUrlsChange.emit([...this.mediaUrls]); 
                    this.hasImageContent = true;

                    // Reset the file input
                    event.target.value = '';
                }
            };

            video.onerror = () => {
                alert('Unable to load the video for validation.');
            };
            video.src = URL.createObjectURL(this.selectedFile);

        } else if (this.selectedFile.type.startsWith('image/')) {


            // Handle image file (non-video)
            const reader = new FileReader();
            reader.onload = (e: any) => {
                //this.handleFileSelect(e.target.result);
                const index = this.mediaUrls.length; // Get the next index
                const mediaItem = {
                    url: URL.createObjectURL(this.selectedFile),
                    file: this.selectedFile,
                    //file: null,
                    isVideo: false,
                    isTenor: false,  // Assuming you're handling only local files here
                    isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                    animatedUrl: null, // Not applicable for local files
                    previewUrl: null,   // For local files, the preview and actual URLs are the same
                    mimeType: mimeType, // Store the extracted MIME type
                    index: index       // Tracking the index of the new item
                };

                this.mediaUrls.push(mediaItem);
                this.mediaUrlsChange.emit([...this.mediaUrls]); 
                //this.mediaUrlsChange.emit(this.mediaUrls);

                console.log("Footer is emitting Videos/Images: ", [...this.mediaUrls]);  // Log emitted data'

                this.isMediaProcessed = true;  

                //this.mediaUrlsChange.emit(this.mediaUrls);
                this.hasImageContent = true;
                // Reset the file input
                event.target.value = '';
            };
            reader.readAsDataURL(this.selectedFile);
        }
        //console.log("Footer Images this.mediaUrls: ", this.mediaUrls);  // Log the entire event to see what properties are available
    //    this.mediaUrlsChange.emit([...this.mediaUrls]); 
    }

    // Toggle play/pause for GIF at specific index
    togglePlay(index: number): void {
        const item = this.mediaUrls[index];
        if (item.isTenor) {
            item.isPlaying = !item.isPlaying;
        }
    }

    removeMediaAtIndex(index: number): void {

        //console.log(`Deleting item at index ${index}`);  // Debugging output
        if (index > -1 && index < this.mediaUrls.length) {
            this.mediaUrls.splice(index, 1);
            this.mediaUrls = [...this.mediaUrls];  // Re-assign to trigger change detection
            //console.log(`Remaining items: ${this.mediaUrls.length}`);  // Check remaining items

            // After removing the item, check if the index is still valid
            if (index >= this.mediaUrls.length) {
                // If the index is out of bounds (e.g., last item was deleted), adjust it
                index = this.mediaUrls.length - 1;
            }

            this.mediaUrlsChange.emit(this.mediaUrls);

            // Manage focus after a slight delay to allow UI updates
            setTimeout(() => {
                this.focusOnCarouselItem(index);
            }, 100);
        }
        else {
            this.hasImageContent = false;
        }
    }

    focusOnCarouselItem(index: number): void {
        const carouselItemElements = document.querySelectorAll('.carousel-item-focusable');
        if (carouselItemElements[index]) {
            (carouselItemElements[index] as HTMLElement).focus();
        }
    }

    updateActiveIndex(event: any): void {
        //console.log(event);  // Log the entire event to see what properties are available
        this.activeIndex = event.page;  // Assuming 'page' is the correct property
    }

    handleSave(): void {
        this.onSave.emit();
    }
}
